import type { FaireProductEntity } from "../../entity_types/product";

export const p_zs2kxjsr2c: FaireProductEntity = {
  token: "p_zs2kxjsr2c",
  type: "product",
  name: "Dome Carved Shiruwan Bowl",
  brandName: "Rainforest Bowls",
  imageUrl:
    "https://cdn.faire.com/fastly/57d65b942816134290d48b36f2c556161d4f46e314fc3f3cb9c3acbaa17693bc.jpeg",
  priceDollars: 16,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/014490c47bb5fc0e93149a1905367b31769d4b9be0894fb8e3b281e198d96ef5.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
